<template>
	<div class="target">
		<managing-section v-if="!isInquiry" :column-count="1">
			<managing-box title="회원 항번">
				<template>
					<textarea
						v-model="idRegisterTextArea"
						class="push-target-direct__id-box"
						@input="input"
						:placeholder="'회원 항번을 한 줄에 1개씩 입력해 주세요.(Enter 구분)\n수동 추가 된 회원 정보는 하단 리스트 내 파란색으로 표기 됩니다.'"
					></textarea>
				</template>
			</managing-box>
		</managing-section>

		<div v-if="!isInquiry" class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="add">
				추가
			</button>
		</div>

		<managing-section :column-count="2">
			<managing-box title="회원 항번">
				<input-text
					ref="idRegister"
					mode="number"
					:input-width="100"
					input-width-unit="%"
					class="target__id-input"
					@input="idRegisterChange"
					@enter="search"
				/>
			</managing-box>
			<managing-box title="닉네임">
				<input v-model="nickname" type="text" @keydown.enter="search" />
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="search">검색</button>
			<button class="btn-main" @click="init">초기화</button>
		</div>

		<managing-section :is-table="true">
			<template slot="infoSection">
				<p class="section__info__left">
					선택 발송 회원 총 {{ list.length }}명
					{{ addIdRegisterCntDesc() }}
				</p>
				<div class="section__info__right">
					<button
						v-if="!isInquiry"
						class="btn-delete section__info__items"
						@click="deleting"
					>
						삭제
					</button>
				</div>
			</template>

			<table v-if="0 < userList.length" class="table-main target__table">
				<thead>
					<tr>
						<th v-if="!isInquiry" class="target__table__checkbox">
							<input
								v-model="allCheckModel"
								:value="isAllCheck"
								type="checkbox"
							/>
						</th>
						<th>항번</th>
						<th>닉네임</th>
						<th>성별</th>
						<th>연령</th>
						<th>이메일주소</th>
						<th>가입일</th>
						<th>피부타입</th>
						<th>단말기</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="item in pagedList">
						<tr
							:key="item.idRegister"
							:style="
								item.isAdd === true ? { color: '#2268b6' } : ''
							"
						>
							<td v-if="!isInquiry">
								<input
									v-model="checkModel"
									:value="item.idRegister"
									type="checkbox"
								/>
							</td>
							<td>{{ item.idRegister }}</td>
							<td>{{ item.nickname }}</td>
							<td>{{ item.gender }}</td>
							<td>{{ item.age }}</td>
							<td>{{ item.email }}</td>
							<td>{{ item.createDate }}</td>
							<td>{{ item.skinType }}</td>
							<td>{{ item.device }}</td>
						</tr>
					</template>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="list.length"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="confirm">확인</button>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import InputText from '@/components/InputText';
	import PaginationBox from '@/components/PaginationBox';
	import filters from '@/filters';
	import Vue from 'vue';

	export default {
		name: 'PushTargetManage',
		components: {
			ManagingSection,
			ManagingBox,
			InputText,
			PaginationBox,
		},
		data() {
			return {
				idRegister: '',
				nickname: '',
				limit: 10,
				offset: 0,
				list: [],
				isAllCheck: false,
				checkList: [],
				idRegisterTextArea: '',
				idRegisterList: [], //직접추가하기 위한 항번 리스트
			};
		},
		computed: {
			...mapState('PushController', ['isInquiry', 'userList']),
			...mapGetters(['getItemById']),
			parsedList() {
				return this.userList
					.filter(item => !item.delete)
					.map(item => ({
						...item,
						gender: item.gender
							? this.getItemById('gender', item.gender).name
							: '',
						skinType: item.skinType
							? this.getItemById('skinType', item.skinType).name
							: '',
						createDate: item.createDate
							? moment(item.createDate * 1000).format(
									'YYYY-MM-DD'
								)
							: '-',
						device: this.getOs(!!item.isIos, !!item.isAos),
					}));
			},
			pagedList() {
				return this.list.slice(this.offset, this.offset + this.limit);
			},
			allCheckModel: {
				get() {
					return this.isAllCheck;
				},
				set(newVal) {
					this.isAllCheck = newVal;
					this.checkList = newVal
						? (this.checkList = this.userList.map(
								item => item.idRegister
							))
						: [];
				},
			},
			checkModel: {
				get() {
					return this.checkList;
				},
				set(newList) {
					this.checkList = newList;
					this.isAllCheck =
						this.checkList.length === this.userList.length;
				},
			},
			getNum() {
				this.idRegisterList = this.idRegisterList.filter(v => !!v);
				return this.idRegisterList.length;
			},
		},
		created() {
			this.initUserList();
		},
		methods: {
			getOs(isIos, isAos) {
				switch (`${isIos}${isAos}`) {
					case 'truetrue':
						return '안드로이드 / iOS';
					case 'truefalse':
						return 'iOS';
					case 'falsetrue':
						return '안드로이드';
				}
			},
			initUserList() {
				this.$store.commit(
					'PushController/initUserList',
					this.userList.map(item => ({
						...item,
						delete: false,
					}))
				);
				this.search();
			},
			idRegisterChange(idRegister) {
				this.idRegister = idRegister;
			},
			search() {
				this.offset = 0;
				this.list = this.parsedList.filter(
					item =>
						(!this.idRegister ||
							Number(this.idRegister) === item.idRegister) &&
						(!this.nickname ||
							item.nickname.indexOf(this.nickname) > -1)
				);
			},
			init() {
				this.$refs.idRegister.init();
				this.idRegister = '';
				this.nickname = '';
				this.search();
			},
			deleting() {
				this.$store.commit(
					'PushController/initUserList',
					this.userList.map(item => ({
						...item,
						delete: this.checkList.some(
							id => id === item.idRegister
						),
					}))
				);

				this.$store.commit('PushController/initAppointAddUserList', {
					addIdRegisters: this.userList
						.filter(item => item.isAdd == true && !item.delete)
						.map(item => {
							return item.idRegister;
						}),
				});

				this.search();
				this.addIdRegisterCntDesc();
			},
			confirm() {
				this.$store.commit('PushController/confirmDeleteUser');
				this.$store.commit('modal/toggleModal', false);
			},
			paging({ offset }) {
				this.offset = offset;
			},
			parseToNumber(value) {
				return this.idRegisterList.map(id => {
					const matchedValue = id.match(/\d+/g);
					return Array.isArray(matchedValue)
						? matchedValue.join('')
						: '';
				});
			},
			input(e) {
				let newValue = e.target.value;
				this.idRegisterList = e.target.value.split(/\r\n|\r|\n/);
				if (newValue !== null && typeof newValue !== 'number') {
					this.idRegisterList = this.parseToNumber(
						this.idRegisterList
					);
				}
				e.target.value = this.idRegisterList.join('\n');
			},

			async add() {
				if (this.getNum < 1) {
					alert('푸시 발송 대상으로 추가할 회원항번을 입력해주세요.');
					return;
				}
				const idRegisters = this.idRegisterList;

				const params = {
					idRegisters,
					limit: 0,
					offset: 0,
				};
				try {
					const { data } = await this.$axiosAdmin2.post(
						'/api/noti/registers/search',
						params
					);
					const contentTotal = data.contentTotal;
					if (
						this.getNum !== contentTotal &&
						!confirm(
							`푸시 발송 대상 중 발송이 불가한 ${this.getNum - contentTotal}명을 제외한 나머지 ${contentTotal}명이 추가되었습니다.`
						)
					) {
						return;
					}

					if (contentTotal > 0) {
						for (const item of data.data) {
							if (
								!this.userList.find(
									a => a.idRegister === item.idRegister
								)
							) {
								item.isAdd = true;
								this.userList.push(item);
							} else {
								this.userList.find(
									a => a.idRegister === item.idRegister
								).delete = false;
							}
						}

						this.$store.commit('PushController/addUserList', {
							userList: this.userList,
							// filter: params,
							count: this.userList.length,
						});

						this.$store.commit(
							'PushController/initAppointAddUserList',
							{
								addIdRegisters: this.userList
									.filter(
										item =>
											item.isAdd == true && !item.delete
									)
									.map(item => {
										return item.idRegister;
									}),
							}
						);

						this.search();
						this.addIdRegisterCntDesc();

						this.idRegisterList = [];
						this.idRegisterTextArea = '';
					}
				} catch (err) {
					console.error(err);
					if (err.response && err.response.status === 452) {
						alert(err.response.data.message);
					} else {
						alert(
							'대상 추가가 불가능 합니다. 개발팀에 문의해주세요.'
						);
					}
				}
			},

			addIdRegisterCntDesc() {
				let cnt = this.userList
					.filter(item => item.isAdd == true && !item.delete)
					.map(item => {
						return item.idRegister;
					}).length;

				if (cnt > 0) {
					return `(수동 추가 ${cnt}명)`;
				} else {
					return '';
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.target__id-input {
		width: 100%;
	}

	.target__table {
		table-layout: fixed;
		width: auto;
		min-width: 100%;

		th,
		td {
			white-space: nowrap;
		}
	}

	.target__table__checkbox {
		width: 40px;
	}

	.blue__text {
		color: #2268b6;
	}
</style>
